import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useRef } from 'react';
import JsonView from '@uiw/react-json-view';
import { GoogleSheetsContext } from '../../cnr/contexts/GoogleSheetsContext';
import { uniqueKey } from "../../common/keys";
import { copyCodeToClipboard } from '../../common_web/copy';
import GenericButton from '../../genericControls/GenericButton';
import FullPageWrapper from '../../wrappers/FullPageWrapper';
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper';
import SearchMenu from '../menus/SearchMenu';
import ListViewer from '../../genericControls/ListViewer';
import { clickOriginTypes } from '../../enums/globalEnums';
import { ParentContext } from 'global/cnr/contexts/ParentContext';
import { nordTheme } from '@uiw/react-json-view/nord';
import TreeViewer from './TreeViewer';

const _allowList = true

/**
 * 
 * @param {object} props (keyy, vlProps, itemData, vit, showButtons, inApp, fullView, saveButton, fullScreen, noFullHeight, ignoreSortKeys)
 * @returns a json viewer
 */
const JsonViewer = (props) => {

  // paste_handlers
  const { keyy, clickOriginType, vlProps, itemData, vit, showButtons, inApp, handleCancel, saveButton, fullScreen, noFullHeight, ignoreSortKeys, ignoreNoMid, asList, useQuick, handleSelect } = props
  const { fieldProps, fip, data_current } = vlProps ?? {}

  const parentContext = useContext(ParentContext)
  const { states } = parentContext
  const { currentSettings_state } = states ?? {}

  // pageContext
  // const pageContext = useContext(PageContext)
  // const { page_state } = pageContext ?? {}
  const { aps_global } = _.get(currentSettings_state, 'gvviSettings', {});
  const { settingsOptions } = aps_global ?? {}
  const { useDarkMode } = settingsOptions ?? {}

  // googleSheetsContext
  const googleSheetsContext = useContext(GoogleSheetsContext)
  const { googleSheets_handlers } = googleSheetsContext ?? {}
  const { handleAmmend_settingsViewer } = googleSheets_handlers ?? {}

  let darkMode = useDarkMode && !inApp ? true : false

  switch (clickOriginType) {
    case clickOriginTypes.sidebar:
      darkMode = true
      break;
    default:
    // nothing
  }


  const { currentJson, currentName } = useMemo(() => {

    let initJson;
    let initName;

    if (vlProps && fip.propname && data_current && data_current[fip.propname]) {
      initName = fip.propname
      initJson = data_current[fip.propname]
    } else if (itemData) {
      initName = vit
      initJson = itemData
    } else {
      initName = props.name
      initJson = props.json
    }

    if (!initName) { initName = 'data' }

    return { currentJson: initJson, currentName: initName }
  }, [fip, props, itemData, data_current])

  const handleOnChange = () => { }

  // const handleDelete = (a, b) => {
  //   if (handleAmmend_settingsViewer) { handleAmmend_settingsViewer(a.updated_src) }
  //   setCurrentJson(a.updated_src)
  // }

  // const handleClick = (kp) => {
  //   console.log('kp', kp)
  // }
  // const doThis = (a) => {
  //   const { updated_src } = a //existing_src
  //   if (paste_handlers && paste_handlers.handleUpdatePaste) { paste_handlers.handleUpdatePaste(updated_src) }
  //   if (form_handlers) {
  //     form_handlers.handleSubPropChange(updated_src, fip.propname)
  //   }
  // }

  const textAreaRef = useRef()

  const copyToClipboard = () => copyCodeToClipboard(textAreaRef)

  let cn = 'json-container app-dark-mode'
  if (noFullHeight) { cn += ' nfh' }
  if (inApp) { cn += ' in-app' }

  const viewer = () => <div key={uniqueKey('jvv', 'hi', keyy ? keyy : 'jvr')} className={cn} >
    {currentJson ? <JsonView
      value={currentJson}
      style={nordTheme}
      collapsed={false}
      displayObjectSize={false}
      displayDataTypes={false}
      enableClipboard={false}
    /> : <div>???</div>}
  </div>

  const treeViewer = () => <div key={uniqueKey('jvv', 'hi', keyy ? keyy : 'jvr')} className={cn} >
    {currentJson ? <TreeViewer
      data={currentJson}
    /> : <div>???</div>}
  </div>

  const listViewer = () => { currentJson ? <ListViewer data={currentJson} dataType={currentName} handleSelect={handleSelect} /> : <div>???</div> }

  const content = () => <React.Fragment>
    {asList && _allowList ? listViewer() : treeViewer()}
    <textarea key={uniqueKey('jv', 'ta')} ref={textAreaRef} value={JSON.stringify(currentJson, null, 3)} style={{ position: 'absolute', left: '-999em' }} onChange={handleOnChange} />
  </React.Fragment>

  const btnProps = { inverted: darkMode }

  const gb = (key, caption, icon, onClick, clickOptions, opts, noE) => <GenericButton gbProps={{ key, caption, icon, onClick, clickOptions, opts, noE }} />

  const header = () => <React.Fragment>
    {showButtons && gb('btn-copy', 'Copy', 'copy', copyToClipboard, null, { ...btnProps })}
    {saveButton && saveButton}
  </React.Fragment>

  const mmm = () => <SearchMenu searchData={currentJson} />

  const viewerWrap = () => <Wrapper
    header={(showButtons || saveButton) && header()}
    content={useQuick ? mmm() : content()}
    noMid={ignoreNoMid ? false : true}
    wrapperType={wrapperTypes.paddedFooter}
    css={{ container: 'ct-json', header: 'padd5' }}
  />

  const fullPageWrapper = () => <FullPageWrapper
    content={viewerWrap()}
    topperCaption={currentName}
    handleCancel={handleCancel}
  />

  if (fullScreen) {
    return fullPageWrapper()
  } else {
    if (vlProps) {
      return <div className={'field-object-container'} key={uniqueKey('jv')}>
        <div key={uniqueKey('jv', 'fl')} className={'field field-label'}>
          <label style={{ float: 'left' }}>{fieldProps.label}</label>
        </div>
        <div key={uniqueKey('jv', 'vw')} className={'field-objects'}>{viewerWrap()}</div>
      </div>
    } else {
      return viewerWrap()
    }
  }
}

export default JsonViewer